class ShowVariants extends HTMLElement {
	constructor() {
		super();
		this.container = this;
        this.selector = this.container.querySelectorAll(".cc__variantselector");
        this.sectionID = this.dataset.target;
        
        this.isClose = document.getElementById('CollectionsList--'+this.sectionID);

        if(this.isClose){
            this.ismodelclose = this.isClose.dataset.closemodal;
        }
        

        if (this.selector.length > 0){
            this.selector.forEach((item) => {
                item.addEventListener("click", this.variantShow.bind(this));
            });
        }


        if(this.ismodelclose != 'false' ){
            document.addEventListener('theme:cart:change', et=>{
                if( document.querySelector('.cc__shopthelook-open-popup')){
                 document.querySelector('.cc__shopthelook-open-popup').classList.remove('cc__shopthelook-open-popup')
                }
             })
        }

	}

    variantShow(et){
        et.currentTarget.classList.toggle('cc_vactive');
        this.querySelectorAll("ul li").forEach(item=>{
            item.addEventListener("click", this.selectorList.bind(this));
        })
    }

    selectorList(et){
        const currentSelected = this.querySelector(".current_selected");
        currentSelected.innerText = et.currentTarget.innerText;
        currentSelected.dataset.value = et.currentTarget.dataset.value;
        let isAvailable = et.currentTarget.dataset.available;

        this.parentElement.querySelector('[name="id"]').value = et.currentTarget.dataset.value;

        if( this.parentElement.parentElement.parentElement.querySelector(".product-upsell__price span") ){
            this.parentElement.parentElement.parentElement.querySelector(".product-upsell__price span").innerText = et.currentTarget.dataset.price;
        }

        if(isAvailable){
            this.querySelector("[data-add-to-cart]").removeAttribute("disabled");
            this.querySelector("[data-add-to-cart]").innerText = theme.strings.addToCart;
        } else {
             this.querySelector("[data-add-to-cart]").setAttribute("disabled");
             this.querySelector("[data-add-to-cart]").innerText = theme.strings.soldOut;
        }

    }
}

if (!customElements.get("show-variants")) {
	customElements.define("show-variants", ShowVariants);
}


let shopthelookitems = document.querySelectorAll('.cc__shopthelook-item-content');
let shopthelookoverlay = document.querySelectorAll('.cc__shopthelook-popup-overlay');

let closebutton = document.querySelectorAll('.close-btn');

if( shopthelookitems.length > 0){
    shopthelookitems.forEach(stl=>{
        stl.addEventListener('click', et=>{
            let targetpopup = et.currentTarget.dataset.target;

            document.getElementById(targetpopup).classList.add('cc__shopthelook-open-popup');
        });
    });
}


if (shopthelookoverlay.length > 0) {
	shopthelookoverlay.forEach((stl) => {
		stl.addEventListener("click", (et) => {
			et.currentTarget.parentElement.classList.remove("cc__shopthelook-open-popup");
		});
	});
}

if( closebutton.length > 0 ){
    closebutton.forEach(btn=>{
        btn.addEventListener('click', etbtn=>{
            let targetpopup = etbtn.currentTarget.dataset.target;
            document.getElementById(targetpopup).classList.remove('cc__shopthelook-open-popup');
        })
    })
}

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', '');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

class AddToCartCheckbox extends HTMLElement {
  static lastChecked = null;
  static checkInterval = 3000; // Check for cart status every 3 seconds
  static cartCheckTimer = null;

  constructor() {
    super();

    // Create label wrapper
    this.labelWrapper = document.createElement('label');
    this.labelWrapper.style.cursor = 'pointer';

    // Create checkbox input
    this.checkbox = document.createElement('input');
    this.checkbox.type = 'checkbox';
    this.checkbox.addEventListener('change', this.toggleCart.bind(this));

    // Create label text
    this.labelText = document.createElement('span');
    this.labelText.textContent = this.getAttribute('label') || 'Add to Cart';

    // Append checkbox and label text to the label wrapper
    this.labelWrapper.appendChild(this.checkbox);
    this.labelWrapper.appendChild(this.labelText);

    // Append the label wrapper to the custom element
    this.appendChild(this.labelWrapper);
  }

  connectedCallback() {
    // Check cart status when the component is connected to the DOM
    this.checkCartStatus();
    this.startCartCheck(); // Start checking for cart status
  }

  disconnectedCallback() {
    // Stop checking for cart status when the component is disconnected
    this.stopCartCheck();
  }

  checkCartStatus() {
    const variantId = this.getAttribute('variant-id');

    // Fetch current cart state
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Check if the product is in the cart
        const itemInCart = cart.items.find(item => item.id == variantId);
        if (itemInCart) {
          this.checkbox.checked = true;
          AddToCartCheckbox.lastChecked = this;
        } else {
          this.checkbox.checked = false;
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  startCartCheck() {
    if (!AddToCartCheckbox.cartCheckTimer) {
      AddToCartCheckbox.cartCheckTimer = setInterval(() => {
        this.checkCartStatus();
      }, AddToCartCheckbox.checkInterval);
    }
  }

  stopCartCheck() {
    clearInterval(AddToCartCheckbox.cartCheckTimer);
    AddToCartCheckbox.cartCheckTimer = null;
  }

  toggleCart() {
    const variantId = this.getAttribute('variant-id');

    if (this.checkbox.checked) {
      // If there's another checkbox checked, uncheck it and remove its item from cart
      if (AddToCartCheckbox.lastChecked && AddToCartCheckbox.lastChecked !== this) {
        AddToCartCheckbox.lastChecked.checkbox.checked = false;
        AddToCartCheckbox.lastChecked.removeFromCart();
      }

      // Set this checkbox as the last checked
      AddToCartCheckbox.lastChecked = this;

      // Add this item to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      })
        .then(response => response.json())
        .then(data => {
          console.log(`Product ${variantId} added to cart:`, data);
          this.updateCart(variantId, 1); // Call to updateCart method
          this.dispatchEvent(
            new CustomEvent('theme:product:add', {
              detail: {
                response: data,
                button: this.checkbox, // Use the checkbox as the button reference
              },
              bubbles: true,
            })
          );

          // Refresh the cart drawer
          this.getCart();
        })
        .catch(error => {
          console.error(`Error adding product ${variantId} to cart:`, error);
          this.checkbox.checked = false; // Revert if there's an error
        });
    } else {
      // Unchecked, so remove item from cart
      this.removeFromCart();
    }
  }

  removeFromCart() {
    const variantId = this.getAttribute('variant-id');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0,
      }),
    })
      .then(response => response.json())
      .then(data => {
        console.log(`Product ${variantId} removed from cart:`, data);
        this.updateCart(variantId, 0); // Call to updateCart method

        // Refresh the cart drawer
        this.getCart();
      })
      .catch(error => {
        console.error(`Error removing product ${variantId} from cart:`, error);
        this.checkbox.checked = true; // Revert if there's an error
      });
  }

  updateCart(variantId, quantity) {
    if (quantity === '') return;

    // Dispatch custom event for theme cart update
    this.dispatchEvent(
      new CustomEvent('theme:cart:update', {
        bubbles: true,
        detail: {
          id: variantId,
          quantity: quantity,
        },
      })
    );
  }

  getCart() {
    fetch(theme.routes.cart_url + '?section_id=api-cart-items')
      .then(this.cartErrorsHandler)
      .then(response => response.text())
      .then(response => {
        const element = document.createElement('div');
        element.innerHTML = response;

        const cleanResponse = element.querySelector('[data-api-content]');
        this.build(cleanResponse);
        console.log(cleanResponse);
      })
      .catch(error => console.log(error));
  }

  cartErrorsHandler(response) {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response;
  }

  build(data) {
    // Update the cart drawer with the clean response content
    const cartPage = document.querySelector('[data-cart-page]');
    const cartDrawer = document.querySelector('cart-drawer');

    const cartItemsData = data.querySelector('[data-api-line-items]');
    const upsellItemsData = data.querySelector('[data-api-upsell-items]');
    const cartEmptyData = Boolean(cartItemsData === null && upsellItemsData === null);
    const priceData = data.querySelector('[data-api-cart-price]');
    const cartTotal = data.querySelector('[data-cart-total]');
    const priceHolder = document.querySelector('[data-cart-price-holder]');
    const upsellProductsHolder = document.querySelector('[data-upsell-products]');
    let subtotal = window.theme.subtotal;
    let cart = cartDrawer || cartPage;

    if (priceHolder && priceData) {
      priceHolder.innerHTML = priceData.innerHTML;
    }

    if (cartEmptyData) {
      document.querySelector('[data-items-holder]').innerHTML = data.innerHTML;

      if (upsellProductsHolder) {
        upsellProductsHolder.innerHTML = '';
      }
    } else {
      document.querySelector('[data-items-holder]').innerHTML = cartItemsData.innerHTML;

      if (upsellProductsHolder) {
        upsellProductsHolder.innerHTML = upsellItemsData.innerHTML;
      }
    }

    subtotal = cartTotal && cartTotal.hasAttribute('data-cart-total') ? parseInt(cartTotal.getAttribute('data-cart-total')) : 0;

    cartTotal.innerHTML = subtotal === 0 ? window.theme.strings.free : formatMoney(subtotal, theme.moneyWithCurrencyFormat);

    // Add class "is-updated" line items holder to reduce cart items animation delay via CSS variables
    if (cartDrawer?.classList.contains('is-open')) {
      cart.classList.add('is-updated');
    }

    // Remove cart loading class
    cart.classList.remove('is-loading');

    cart?.querySelectorAll('[data-animation]').forEach((item) => {
      item.classList.add('is-animated');
    });

    document.dispatchEvent(
      new CustomEvent('theme:product:added', {
        bubbles: true,
      })
    );
  }
}

// Define the custom element
customElements.define('add-to-cart-checkbox', AddToCartCheckbox);

class GiftWrapProduct extends HTMLElement {
  static lastChecked = null;

  constructor() {
    super();

    // Create the label element and set it as clickable
    this.label = document.createElement('label');
    this.label.style.cursor = 'pointer';

    // Create the checkbox input
    this.checkbox = document.createElement('input');
    this.checkbox.type = 'checkbox';
    this.checkbox.id = 'gift-wrap-checkbox';
    this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));

    // Append the checkbox to the label so that the whole label is clickable
    this.label.appendChild(this.checkbox);

    // Add label text
    const labelText = document.createElement('span');
    labelText.textContent = this.getAttribute('label') || 'Add Gift Wrap';
    this.label.appendChild(labelText);

    // Append the label to the custom element
    this.appendChild(this.label);

    this.sectionid = this.closest('.product-form').dataset.sectionid;
    this.mainatc = document.querySelector(`#AddToCart--${this.sectionid}`);
    this.atc = document.querySelector(`#AddToCart--giftwrap${this.sectionid}`);

    // this.mainatc.addEventListener('click', ()=>{
    //   setTimeout(()=>{this.atc.click()}, 600);
    // })
  }

  connectedCallback() {
    // Find the "Add to Cart" button in the closest product form
    const productForm = this.closest('.product-form');
    if (productForm) {
      this.addToCartButton = productForm.querySelector('[type="submit"]');
      
      if (this.addToCartButton) {
        // Disable the button initially if no checkbox is checked
        this.updateButtonState();

        // Add an event listener for the button click
        this.addToCartButton.addEventListener('click', this.handleAddToCartClick.bind(this));
      }
    }
  }

  handleCheckboxChange() {
    const variantId = this.getAttribute('gift-variant-id'); // Gift wrap product variant ID
    const closestInput = this.closest('.product-form').querySelector('input[name="id"]');

    if (this.checkbox.checked) {
      // Uncheck the previously checked checkbox, if any
      if (GiftWrapProduct.lastChecked && GiftWrapProduct.lastChecked !== this) {
        GiftWrapProduct.lastChecked.checkbox.checked = false;
      }

      // Update the closest input[name="id"] with the gift wrap variant ID
      if (closestInput) {
        closestInput.value = variantId;
      }

      // Update the last checked reference to this checkbox
      GiftWrapProduct.lastChecked = this;
    } else {
      // Clear the input[name="id"] if the checkbox is unchecked
      if (closestInput) {
        closestInput.value = '';
      }
      GiftWrapProduct.lastChecked = null;
    }

    // Update button state based on checkbox state
    this.updateButtonState();
  }

  handleAddToCartClick(event) {
    const productForm = this.closest('.product-form');
    const variantId = this.getAttribute('gift-variant-id');
    const closestInput = productForm.querySelector('input[name="id"]');

    // If the checkbox is checked, set the variant ID
    if (this.checkbox.checked && closestInput) {
      closestInput.value = variantId;
    }
  }

  updateButtonState() {
    if (this.addToCartButton) {
      // Disable the button if no checkbox is checked, enable it if one is checked
      this.addToCartButton.disabled = !this.checkbox.checked;
    }
  }
}

// Define the custom element
customElements.define('gift-wrap-product', GiftWrapProduct);


